import Dropdown from '~/components/Dropdown';
import {
  listaRelacaoEN,
  tipoPedidoEN,
  quemSouEN,
  segments,
  brands,
} from '../../helpers/texts';
import Input from '~/components/Input';
import InputFile from '~/components/InputFile';
import { Checkbox, Radio } from '@mui/material';
import Image from 'next/image';
import LanguageSelector from '~/components/LanguageSelector';
import { languages } from '~/helpers/constants';
import { RadioGroup } from '@headlessui/react';
import InputPhone from '~/components/InputPhone';
import Loading from '~/components/Loading';
import ReCAPTCHA from 'react-google-recaptcha';
import Modal from 'react-modal';
import useFormTools from '~/helpers/useFormTools';

Modal.setAppElement('#__next');

const Formulario: React.FC = () => {
  const {
    customStyles,
    submitForm,
    handleBrandsAndSegments,
    loading,
    warning,
    isModalOpen,
    handleCaptchaChange,
    formValues,
    handleForm,
    isEmployeeRelated,
    isSupplier,
    isNeededBrandAndSegments,
    emailRegex,
    isButtonEnabled,
    setIsModalOpen,
  } = useFormTools('en');

  return (
    <div>
      <div className="h-[120px] w-full">
        <div className="m-auto flex h-full max-w-[968px] justify-between">
          <Image
            src="/Images/LOGO_ENG.svg"
            alt="logo"
            width={250}
            height={75}
          />
          <LanguageSelector
            options={languages}
            className="my-auto"
            currentSelectedOption={languages[1]}
          />
        </div>
      </div>
      <div className="mx-auto max-w-[968px] px-3 pt-3">
        <h1 className="text-center text-[30px] font-semibold">
          Welcome to the Personal Data Subjects Channel – Peipedê
        </h1>
        <h3 className="mt-5 text-sm">
          Here you can exercise your rights as a Data Subject ensured by all
          applicable laws, such as the LGPD (Law 13,709/2020).
        </h3>
        <h2 className="mt-5 text-xl">
          Do you have a query about the rights that the Law ensures?
        </h2>
        <p className="mt-2 text-sm">
          Access &quot;
          <a
            className="text-red-700"
            href="https://cdn.prod.website-files.com/69cb021343dbf125cabfa994/6a1de5d6ca211356cc654904_Privacy%20notice%20website.pdf"
            target="_blank"
          >
            here
          </a>
          &quot; our P&DP Notice or contact the party responsible for processing
          Suzano’s personal data using the form that you can find on this page.
        </p>
        <h2 className="mt-5 text-xl">Guidelines:</h2>
        <p className="mt-2 text-sm">
          <ul className="ml-10 text-justify">
            <li style={{ listStyle: 'outside' }}>
              <b>Applicant Identity Validation:</b>
              &nbsp; The deadline for responding to your request will start from
              the date validation of your identity, respecting the limits
              established by the applicable regulations. If validation is not
              possible, Suzano will contact you through the means available
              here, and if we do not receive a response within 07 (seven) days,
              the request will be closed. With that in mind, remember to enter
              your best contact email.
            </li>
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              <b>How to track the request:</b>
              &nbsp; You will receive via email lgpd@Suzano.com.br a unique
              identifier (ID) after completing your request. If you would like
              information on the status of your request, please send us an email
              with your ID number. In addition, we will contact you whenever
              there are updates on your order.
            </li>
          </ul>
        </p>
        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            DATA SUBJECTS&apos; RIGHTS
          </h1>
        </div>
        <p className="my-10 text-sm">Selet the type of request (Mandatory)</p>

        <div className="mt-2">
          <div className="font-semibold">You would like to *</div>
          <Dropdown
            label="Define what your request is"
            options={tipoPedidoEN}
            currentSelectedOption={
              tipoPedidoEN.filter(tipo => tipo.name === formValues.request)[0]
            }
            warning={warning && formValues.request === ''}
            onChange={value => handleForm('request', value?.target as string)}
          />
        </div>

        <div className="mt-2">
          <div className="font-semibold">Detail your request *</div>
          <textarea
            className={`w-full rounded-md border-2 
            ${
              warning && formValues.requestDetail === ''
                ? 'border-erro-bordocaulequente50'
                : 'border-neutra3-cinzaquente70 '
            }
            text-sm text-neutra3-cinzaquente10 focus:border-neutra3-cinzaquente50 focus:ring-0`}
            name="descricao"
            placeholder="Describe your request in details"
            id=""
            cols={30}
            rows={3}
            value={formValues.requestDetail}
            onChange={event => handleForm('requestDetail', event.target.value)}
          />
        </div>

        <div className="my-4 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            REQUESTOR IDENTIFICATION
          </h1>
        </div>

        <RadioGroup value={formValues.iAm} onChange={e => handleForm('iAm', e)}>
          <RadioGroup.Label
            className={`${
              warning && formValues.iAm === ''
                ? 'text-erro-bordocaulequente50'
                : 'text-black'
            } font-semibold`}
          >
            I am: *
          </RadioGroup.Label>
          {quemSouEN.map(item => (
            <RadioGroup.Option value={item.name} key={item.name}>
              {({ checked }) => (
                <span className="flex items-center">
                  <Radio
                    size="small"
                    checked={checked}
                    sx={{
                      color: warning && formValues.iAm === '' ? '#DA253F' : '',
                      '&.Mui-checked': {
                        color: '#1932C8',
                      },
                    }}
                  />
                  {item.name}
                </span>
              )}
            </RadioGroup.Option>
          ))}
        </RadioGroup>
        {formValues.iAm === 'Legal Representative' && (
          <ul className="ml-10 text-justify">
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              If your request concerns personal data of another individual, you
              must provide us with a power of attorney, with notarized
              signature, that authorizes you to exercise the rights on behalf of
              this Data Subject, as well as add the copy of the third-party
              requester’s document to this request.
            </li>
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              If your request concerns data on a minor, you must add a copy of
              the minor’s document and a document, with notarized validity, that
              proves responsibility for the minor to this request.
            </li>
          </ul>
        )}
        <div className="mt-2">
          <div className="font-semibold">My relationship with Suzano</div>
          <Dropdown
            label="Especifique sua relação com a Suzano"
            options={listaRelacaoEN}
            currentSelectedOption={
              listaRelacaoEN.filter(
                tipo => tipo.name === formValues.relation,
              )[0]
            }
            warning={warning && formValues.relation === ''}
            onChange={value => handleForm('relation', value?.target as string)}
          />
        </div>

        <div>
          {isEmployeeRelated && (
            <div className="my-4 flex gap-8 bg-primaria-azulsuzano80 px-8 py-6">
              <div className="w-full">
                <div className="font-semibold">If Employee *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.np === ''}
                  value={formValues.np}
                  placeholder="Insert your NP xxxx"
                  onChange={event => handleForm('np', event.target.value)}
                />
              </div>
              <div className="w-full">
                <div className="font-semibold">Insert your e-mail *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.suzano_mail === ''}
                  value={formValues.suzano_mail}
                  placeholder="Insert your e-mail @suzano"
                  onChange={event =>
                    handleForm('suzano_mail', event.target.value)
                  }
                />
              </div>
            </div>
          )}
          {isSupplier && (
            <div className="my-4 flex gap-8 bg-primaria-azulsuzano80 px-8 py-6">
              <div className="w-full">
                <div className="font-semibold">
                  If Supplier or Service Provider *
                </div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.supplier === ''}
                  value={formValues.supplier}
                  placeholder="Insert your Third-Party NP or Supplier Code (SAP)"
                  onChange={event => handleForm('supplier', event.target.value)}
                />
              </div>
              <div className="w-full">
                <div className="font-semibold">Insert your e-mail *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.corp_mail === ''}
                  value={formValues.corp_mail}
                  placeholder="Insert your corporate e-mail"
                  onChange={event =>
                    handleForm('corp_mail', event.target.value)
                  }
                />
              </div>
            </div>
          )}
          {isNeededBrandAndSegments && (
            <div className="my-4">
              <h2>
                Select the segments and brands that you had your data processed
              </h2>
              <div className="grid grid-cols-2 bg-primaria-azulsuzano90 px-8 py-6">
                <div className="col-span-1 flex flex-col">
                  <h2 className="mb-1 font-semibold">Specify segments *</h2>
                  {segments.map(segment => (
                    <span key={segment}>
                      <input
                        type="checkbox"
                        id={segment}
                        checked={formValues.segments.includes(segment)}
                        className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                        onClick={() =>
                          handleBrandsAndSegments('segments', segment)
                        }
                      />
                      <label htmlFor={segment}>{segment}</label>
                    </span>
                  ))}
                  <span>
                    <input
                      id="other segment"
                      type="checkbox"
                      checked={formValues.segments.includes('Others')}
                      className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                      onClick={() =>
                        handleBrandsAndSegments('segments', 'Others')
                      }
                    />
                    <label htmlFor="other segment">Others</label>
                  </span>
                </div>
                <div className="col-span-1 flex flex-col">
                  <h2 className="mb-1 font-semibold">Specify the brands *</h2>
                  {brands.map(brand => (
                    <span key={brand}>
                      <input
                        type="checkbox"
                        id={brand}
                        checked={formValues.brands.includes(brand)}
                        className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                        onClick={() => handleBrandsAndSegments('brands', brand)}
                      />
                      <label htmlFor={brand}>{brand}</label>
                    </span>
                  ))}
                  <span>
                    <input
                      id="other brand"
                      type="checkbox"
                      checked={formValues.brands.includes('Others')}
                      className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                      onClick={() =>
                        handleBrandsAndSegments('brands', 'Others')
                      }
                    />
                    <label htmlFor="other brand">Others</label>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-2">
          <div className="font-semibold">Full Name *</div>
          <Input
            style="w-full"
            warning={warning && formValues.fullName === ''}
            value={formValues.fullName}
            placeholder="Please enter your full name"
            onChange={event => handleForm('fullName', event.target.value)}
          />
        </div>

        <div className="mt-10 flex w-full gap-10">
          <span className="w-full">
            <div className="font-semibold">Cell number</div>
            <InputPhone
              style="w-full"
              onChange={handleForm}
              value={formValues.cellNumber}
            />
          </span>
          <span className="w-full">
            <div className="font-semibold">E-mail Address *</div>
            <Input
              type="email"
              style="w-full"
              warning={
                formValues.eMail !== '' && !emailRegex.test(formValues.eMail)
              }
              value={formValues.eMail}
              placeholder="Please enter your e-mail"
              onChange={event => handleForm('eMail', event.target.value)}
            />
          </span>
        </div>
        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            ANNEXES - VERIFICATION OF IDENTITY
          </h1>
        </div>

        <p className="mt-3 text-justify text-sm">
          To meet your request and ensure the security of your personal data,
          Suzano verifies your identity.
          <br />
          <br />
          To do this as quickly and securely as possible, you must attach a
          “photo” identifying yourself with full name, holding/presenting an
          identification document with photo, so that the information on the
          document is legible for validation purposes. <br />
          <br />
          Identification documents allowed: <br />
          <br />
          <ul className="ml-10">
            <li style={{ listStyle: 'outside' }}>
              Social Security Number, Tax Identification Number or driver&apos;s
              license.
            </li>
          </ul>
          <br />
          If, at the time of validating your identity, there is any
          inconsistency, Suzano will contact you via your registered e-mail to
          request additional information.
        </p>
        <div className="relative">
          <InputFile
            label="Click to upload your photo *"
            accept="image/*"
            style="mt-3"
            className=""
            multiple
            onChange={event => handleForm('photo', event.target.files[0])}
          />
          {warning && formValues.photo === null && (
            <p className="absolute bottom-[-16px] text-xs text-erro-bordocaulequente50">
              Please, upload the image of your document
            </p>
          )}
          {formValues.photo !== null && (
            <p className="absolute bottom-[-16px] text-xs text-primaria-azulsuzano50">
              {formValues.photo.name}
            </p>
          )}
        </div>

        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            PRIVACY AND PERSONAL DATA PROTECTION NOTICE.
          </h1>
        </div>
        <p className="mt-3 text-justify text-sm">
          We value your privacy and the protection of your personal data,
          therefore, your information will be processed by Suzano in accordance
          with the provisions of its{' '}
          <b>Privacy and Personal Data Protection Notice.</b>
        </p>
        <div className="mt-3 flex">
          <Checkbox
            checked={formValues.authorize}
            sx={{
              color: warning && !formValues.authorize ? '#DA253F' : '',
              '&.Mui-checked': {
                color: '#1932C8',
              },
            }}
            onChange={event => handleForm('authorize', event.target.checked)}
          />
          <div className="text-sm">
            I AUTHORIZE Suzano to process my personal data, and/or the personal
            data of the person I represent, for the purposes and in the ways
            described above. By submitting this request and the requested
            personal data, I declare, for the appropriate purposes, that I am of
            legal age and/or responsible for my minor dependents.
          </div>
        </div>
        <div className="relative mt-5 flex justify-center">
          <button
            className="mb-10 rounded-md bg-secundaria-verdebroto50 p-3 font-semibold text-white disabled:cursor-not-allowed disabled:bg-secundaria-verdefolha50 disabled:text-neutra3-cinzaquente50"
            disabled={!formValues.authorize}
            onClick={submitForm}
          >
            Submit Request
          </button>
          {warning && !isButtonEnabled && (
            <p className="absolute bottom-3 rounded-md bg-erro-bordocaulequente50 px-2 py-1 text-xs font-semibold text-white">
              Please fill in all required fields correctly
            </p>
          )}
        </div>
      </div>
      {loading && <Loading />}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        style={customStyles}
      >
        <h2 className="mb-4 mt-9">Please complete the reCAPTCHA</h2>
        <ReCAPTCHA
          sitekey="6Lckr0UqAAAAAFFeywsJEB-jsKp5D0mUUaAx8uTA"
          onChange={handleCaptchaChange}
        />
      </Modal>
    </div>
  );
};

export default Formulario;
